import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {TableService} from "../../../../../core/services/table.service";
import {GeneralService} from "../../../../../core/services/general.service";

@Component({
  selector: 'app-confirm',
  standalone: true,
  imports: [],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.scss'
})
export class ConfirmComponent {
  @Input() confirmAction!: (data: any) => void;
  @Input() data: any;

  constructor(public modalService :NgbModal, private service: TableService, private generalService: GeneralService){
  }
  confirmDelete() {
    this.service.deleteRow(this.data).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          } else {
            this.generalService.showMessage('success', res.message, 10000);
            if (this.confirmAction) {
              this.confirmAction(this.data); // Ejecuta la función pasada
            }
            this.modalService.dismissAll();  // Cierra la modal
          }
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        }
    );
  }
}
